export default {
  pageTitle: 'ブログ',
  pageSubtitle: 'ペットケアの専門的なヒントとガイド',
  searchPlaceholder: '記事を検索...',
  categories: {
    all: 'すべての記事',
    health: '健康',
    nutrition: '栄養',
    training: 'トレーニング',
    grooming: 'グルーミング',
    lifestyle: 'ライフスタイル',
    news: 'ニュース'
  },
  sortNewest: '新しい順',
  sortOldest: '古い順',
  readMore: '記事を読む',
  minutesRead: '分',
  noArticlesFound: '記事が見つかりません',
  noArticlesDescription: '検索条件やフィルターを調整してください',
  clearFilters: 'すべてのフィルターをクリア',
  backToBlog: 'ブログに戻る',
  shareArticle: '共有',
  relatedArticles: '関連記事',
  tags: 'タグ',
  featured: '注目',
  article: '記事',
  articles: '記事',
  showing: '表示中',
  tableOfContents: '目次'
};